import { render, staticRenderFns } from "./MomentsIcon.vue?vue&type=template&id=7d89477e&"
import script from "./MomentsIcon.vue?vue&type=script&lang=js&"
export * from "./MomentsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports